// Copyright (c) 2021 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.

const brand = {
  main: '#5A946E',
  'forest-green': '#123F22',
  'lime-green': '#44FF00',
};

const state = {
  error: '#F74D4D',
  warning: '#FFB421',
  success: '#05B246',
  info: '#078FD8',
};

export const grey = {
  50: '#F7F7F7',
  100: '#F4F4F4',
  200: '#E9E9E9',
  300: '#D4D4D3',
  400: '#BEBEBE',
  500: '#A9A8A8',
  600: '#939392',
  700: '#7E7D7C',
  800: '#686767',
  900: '#535251',
  1000: '#3C3C3B',
};

export const badge = {
  badge1: '#D07A24',
  badge2: '#C34E52',
  badge3: '#9B6EA6',
  badge4: '#5A83BD',
  badge5: '#3187A6',
  badge6: '#369E73',
};

export default {
  state,
  brand,
  badge,
  grey,
};
